import React, { Component } from 'react';
import AccountsStore from '../stores/AccountsStore';
import UserManagementStore from '../stores/UserManagementStore';

/**
 * Provides some basic information related to whether the current use is an
 * SME User – and has the ability to make SME Payments – to the Wrapped Component.
 * @note
 * The values of `paymentCapableAccounts`, `hasPaymentCapability` and `isSMEUser`
 * are not updated after the first render, as their values are retrived only
 * within the constructor (previously this was in `componentWillMount()`).
 * If you need to respond to changes in the values, it may be best to
 * check the values of these stores yourself within your componenent.
 */
function RequiresSME(WrappedComponent) {
  return class extends Component {
    constructor(props) {
      super(props);

      this.state = {
        paymentCapableAccounts: AccountsStore.getAllSMEPaymentCapableAccounts(),
        hasPaymentCapability: AccountsStore.SMEHasPaymentCapability(),
        isSMEUser: UserManagementStore.isSMEUser(),
      };
    }

    render() {
      return <WrappedComponent {...{ ...this.state, ...this.props }} />;
    }
  };
}

export { RequiresSME };
